import React from "react";
import { Input } from 'reactstrap';
import Select from "react-select";
import AsyncSelect from "react-select/async";
import CreateableSelect from 'react-select/creatable'
import "react-phone-input-2/lib/bootstrap.css";
import PhoneInput from "react-phone-input-2";

const handleStyle = {
  control: (base, state) => ({
    ...base,
    border: "1px solid var(--danger)",
    boxShadow: " 0px 0px 0px 0 var(--danger)",
    borderColor: "1px solid var(--danger)",
    "&:hover": "transparent",
  }),
};

export const FormSelects = (props) => {
  const {
    id,
    // id untuk <input> di dalam select, supaya bisa dirujuk <label htmlFor>.
    inputId,
    name,
    isClearable,
    isLoading,
    isMulti,
    options,
    value,
    error,
    errorMessage,
    onChange,
    onBlur,
    onFocus,
    placeholder,
    defaultValue,
    isDisabled,
    styles,
    menuPortalTarget,
    isOptionDisabled,
    closeMenuOnSelect,
    menuPosition,
    hideSelectedOptions,
    formatOptionLabel,
    getOptionValue,
    getOptionLabel,
    noOptionMessage = "No Data"
  } = props;
  const theValues = (Options, Value) => {
    return Options && Value
      ? Options.find((option) => option.value === Value)
      : null;
  };

  return (
    <div className="w-100">
      <Select
        classNamePrefix="app-select"
        className={errorMessage ? "is-invalid" : ""}
        name={name}
        id={id}
        inputId={inputId}
        options={options}
        styles={styles}
        menuPortalTarget={menuPortalTarget}
        formatOptionLabel={formatOptionLabel}
        isOptionDisabled={isOptionDisabled}
        getOptionValue={getOptionValue}
        menuPosition={menuPosition}
        getOptionLabel={getOptionLabel}
        closeMenuOnSelect={closeMenuOnSelect}
        onChange={(valueProps) => onChange(valueProps)}
        onBlur={onBlur}
        onFocus={onFocus}
        value={isMulti ? value : theValues(options, value)}
        placeholder={placeholder}
        defaultValue={defaultValue}
        isDisabled={Boolean(isDisabled)}
        isClearable={Boolean(isClearable)}
        isLoading={Boolean(isLoading)}
        isSearchable={true}
        isMulti={Boolean(isMulti)}
        noOptionsMessage={() => (noOptionMessage)}
      />
      {errorMessage && (
        <div className="d-block invalid-feedback">{errorMessage}</div>
      )}
    </div>
  );
};

export const FormSelectsAsync = (props) => {
  const {
    id,
    loadOptions,
    name,
    isClearable,
    isLoading,
    isMulti,
    options,
    value,
    styles,
    error,
    errorMessage,
    defaultOptions,
    className,
    onChange,
    onBlur,
    placeholder,
    isDisabled,
    noOptionMessage = "No Data"
  } = props;
  const theValues = (Options, existedValue) => {
    return Options
      ? Options.find(
        ({ value, label }) => existedValue === value || existedValue === label
      )
      : "";
  };
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <AsyncSelect
        classNamePrefix="app-select"
        className={errorMessage ? "is-invalid" : className ? className : ""}
        cacheOptions
        id={id}
        name={name}
        loadOptions={loadOptions}
        styles={error ? handleStyle : styles ? styles : ""}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        defaultOptions={defaultOptions}
        options={options}
        value={isMulti ? value : theValues(options, value)}
        isDisabled={Boolean(isDisabled)}
        isClearable={Boolean(isClearable)}
        isLoading={Boolean(isLoading)}
        isSearchable={true}
        isMulti={Boolean(isMulti)}
        noOptionsMessage={() => (noOptionMessage)}
      />
      {errorMessage && (
        <div className="d-block invalid-feedback">{errorMessage}</div>
      )}
    </div>
  );
};

export const FormInputs = (props) => {
  const {
    autoComplete,
    className,
    name,
    type,
    error,
    placeholder,
    onChange,
    onBlur,
    value,
    required,
    errorMessage,
    isDisabled,
    defaultValue,
    inputMode,
    onFocus,
    invalid,
    ref
  } = props;
  return (
    <div style={{ width: "100%" }}>
      <Input
        name={name}
        type={type}
        className={className || ""}
        rows="3"
        placeholder={placeholder || ""}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        disabled={isDisabled}
        required={required}
        defaultValue={defaultValue}
        autoComplete={autoComplete}
        inputMode={inputMode}
        invalid={!!errorMessage}
        onFocus={onFocus}
        ref={ref}
      />
      {errorMessage && (
        <div className="d-block invalid-feedback">{errorMessage}</div>
      )}
    </div>
  );
};

export const FormInputsCheckbox = (props) => {
  const {
    autoComplete,
    className,
    name,
    type,
    error,
    placeholder,
    onChange,
    onBlur,
    value,
    required,
    errorMessage,
    isDisabled,
    defaultValue,
    inputMode,
    invalid,
  } = props;
  return (
    <div className="card-content" style={{ borderRadius: '2px !important' }}>
      <div className="card-body">
        <Input
          name={name}
          type={type}
          className={className || ""}
          rows="3"
          placeholder={placeholder || ""}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          disabled={isDisabled}
          required={required}
          defaultValue={defaultValue}
          autoComplete={autoComplete}
          inputMode={inputMode}
          invalid={!!errorMessage}
        />
        {errorMessage && (
          <div className="d-block invalid-feedback">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};

export const FormInputsPhone = (props) => {
  const {
    className,
    name,
    type,
    error,
    placeholder,
    onChange,
    onBlur,
    value,
    required,
    errorMessage,
    isDisabled,
    enableSearch,
    country,
  } = props;
  return (
    <div>
      <PhoneInput
        inputProps={{
          name: name,
          required: required,
          className: error
            ? `form-control is-invalid ${className ? className : ""}`
            : `form-control ${className ? className : ""}`,
        }}
        enableAreaCodeStretch
        masks={".................."}
        isValid={(value, country) => {
          if (value.match(/12345/)) {
            return "Invalid value: " + value + ", " + country.name;
          } else if (value.match(/1234/)) {
            return false;
          } else {
            return true;
          }
        }}
        dis
        type={type}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        disabled={isDisabled}
        autoComplete={"tel"}
        inputMode={"numeric"}
        country={country}
        enableSearch={enableSearch}
      />
      {error && errorMessage && (
        <div className="d-block invalid-feedback">{errorMessage}</div>
      )}
    </div>
  );
};

export const FormCreatableSelects = (props) => {
  const {
    id,
    name,
    isClearable,
    isLoading,
    isMulti,
    options,
    value,
    error,
    errorMessage,
    onChange,
    onBlur,
    onFocus,
    placeholder,
    defaultValue,
    isDisabled,
    styles,
    menuPortalTarget,
    menuPosition,
    formatCreateLabel,
    onCreateOption,
    onInputChange,
    isValidNewOption,
    backspaceRemovesValue,
    noOptionMessage = "No Data"
  } = props;
  const theValues = (Options, Value) => {
    return Options && Value
      ? Options.find((option) => option.value === Value)
      : null;
  };

  return (
    <div className="w-100">
      <CreateableSelect
        classNamePrefix="app-select"
        className={errorMessage ? "is-invalid" : ""}
        name={name}
        isValidNewOption={isValidNewOption}
        onCreateOption={onCreateOption}
        formatCreateLabel={formatCreateLabel}
        onInputChange={onInputChange}
        id={id}
        options={options}
        styles={styles}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPosition}
        onChange={(valueProps) => onChange(valueProps)}
        onBlur={onBlur}
        isClearable={isClearable}
        backspaceRemovesValue={backspaceRemovesValue}
        onFocus={onFocus}
        value={isMulti ? value : theValues(options, value)}
        placeholder={placeholder}
        defaultValue={defaultValue}
        isDisabled={Boolean(isDisabled)}
        isClearable={Boolean(isClearable)}
        isLoading={Boolean(isLoading)}
        isSearchable={true}
        isMulti={Boolean(isMulti)}
        noOptionsMessage={() => (noOptionMessage)}
      />
      {errorMessage && (
        <div className="d-block invalid-feedback">{errorMessage}</div>
      )}
    </div>
  );
};